import { combineReducers } from "redux";
import downloadReducer from "./downloadReducer";
import helperReducer from "./helperReducer";

export default combineReducers({
    helpers: helperReducer,
    download: downloadReducer,
})